import { Box, Grid, Paper } from "@material-ui/core";
import React from "react";
import ButtonSearch from "./ButtonSearch";
import FieldDates from './FieldDates';
import FieldHaveError from "./FieldHaveError";
import FieldMarketplace from "./FieldMarketplace";
import FieldProductArticle from "./FieldProductArticle";
import FieldProductId from "./FieldProductId";
import FieldStatus from "./FieldStatus";
import FieldType from './FieldType';
import { PageFilterFC } from "./types";

const PageFilter: PageFilterFC = () => (
  <Paper>
    <Box padding={2}>
      <Grid container spacing={2} alignItems={"center"}>
        <Grid item xs={12} sm={6} md={6} lg={5}>
          <FieldDates />
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <FieldMarketplace />
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <FieldHaveError />
        </Grid>
        <Grid item xs={12} sm={3} md={3} lg={2}>
          <FieldStatus />
        </Grid>
        <Grid item xs={12} sm={3} md={3} lg={2}>
          <FieldType />
        </Grid>
        <Grid item xs={12} sm={3} md={2} lg={2}>
          <FieldProductId />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <FieldProductArticle />
        </Grid>
        <Grid item xs={12} sm={3} md={2} lg={2}>
          <ButtonSearch />
        </Grid>
      </Grid>
    </Box>
  </Paper>
);

export default PageFilter;
